import {ChangeDetectionStrategy, Component} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Component({
    selector: 'page-terms',
    imports: [],
    templateUrl: './terms.page.html',
    styleUrl: './terms.page.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsPage {
}
